import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1" data-testid="site-navigation">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
          <a href="#top" className="navigation-logo-link" data-testid="nav-logo-link">
            <img
              alt="Leelanau Dock & Hoist logo"
              src="/logo.png"
              className="navigation-image"
              data-testid="nav-logo"
            />
          </a>
          <div className="navigation-desktop-menu">
            <a href="#about" data-testid="nav-link-about">
              <div className="navigation-link">
                <span>About</span>
              </div>
            </a>
            <a href="#services" data-testid="nav-link-services">
              <div className="navigation-link">
                <span>Services</span>
              </div>
            </a>
            <a href="#gallery" data-testid="nav-link-gallery">
              <div className="navigation-link">
                <span>Gallery</span>
              </div>
            </a>
            <a href="#service-area" data-testid="nav-link-service-area">
              <div className="navigation-link">
                <span>Service Area</span>
              </div>
            </a>
            <a
              href="tel:+12314926114"
              className="navigation-phone-inline"
              data-testid="nav-phone-link"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>231-492-6114</span>
            </a>
            <a href="#contact-form" data-testid="nav-cta-quote">
              <div className="btn-sm btn btn-primary">
                <span>Request a Quote</span>
              </div>
            </a>
          </div>
          <button
            id="nav-toggle"
            type="button"
            aria-label="Toggle navigation menu"
            aria-controls="mobile-overlay"
            aria-expanded="false"
            className="navigation-mobile-toggle"
            data-testid="nav-mobile-toggle"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M4 6h16M4 12h16M4 18h16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </nav>
      <div
        id="mobile-overlay"
        aria-hidden="true"
        className="navigation-mobile-overlay"
      >
        <div className="navigation-overlay-header">
          <a href="#top" className="navigation-logo-link">
            <img
              alt="Leelanau Dock & Hoist logo"
              src="/logo.png"
              className="navigation-image-mobile"
            />
          </a>
          <button
            id="nav-close"
            type="button"
            aria-label="Close navigation menu"
            className="navigation-mobile-close"
            data-testid="nav-mobile-close"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
        <div className="navigation-overlay-content">
          <div className="navigation-mobile-links">
            <a href="#about">
              <div className="navigation-mobile-link">
                <span>About</span>
              </div>
            </a>
            <a href="#services">
              <div className="navigation-mobile-link">
                <span>Services</span>
              </div>
            </a>
            <a href="#gallery">
              <div className="navigation-mobile-link">
                <span>Gallery</span>
              </div>
            </a>
            <a href="#service-area">
              <div className="navigation-mobile-link">
                <span>Service Area</span>
              </div>
            </a>
            <a href="tel:+12314926114">
              <div className="navigation-mobile-link">
                <span>Call 231-492-6114</span>
              </div>
            </a>
            <div className="navigation-mobile-cta">
              <a href="#contact-form">
                <div className="btn-lg btn btn-primary">
                  <span>Request a Quote</span>
                </div>
              </a>
            </div>
          </div>
          <div className="navigation-overlay-footer">
            <p className="navigation-footer-text">
              Owned &amp; operated out of Suttons Bay, MI
            </p>
            <p className="navigation-footer-subtext">
              Dock installation · Hoist sales · Seasonal service
            </p>
          </div>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const toggleBtn = document.getElementById("nav-toggle")
  const closeBtn = document.getElementById("nav-close")
  const overlay = document.getElementById("mobile-overlay")
  const body = document.body

  if (!toggleBtn || !closeBtn || !overlay) return;

  const openMenu = () => {
    overlay.classList.add("is-active")
    overlay.setAttribute("aria-hidden", "false")
    toggleBtn.setAttribute("aria-expanded", "true")
    body.style.overflow = "hidden"
  }

  const closeMenu = () => {
    overlay.classList.remove("is-active")
    overlay.setAttribute("aria-hidden", "true")
    toggleBtn.setAttribute("aria-expanded", "false")
    body.style.overflow = ""
  }

  toggleBtn.addEventListener("click", openMenu)
  closeBtn.addEventListener("click", closeMenu)

  overlay.querySelectorAll(".navigation-mobile-link, .btn").forEach((link) => {
    link.addEventListener("click", closeMenu)
  })

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-active")) {
      closeMenu()
    }
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
